export enum EVENTS {
  ElementClicked = 'redventures.usertracking.v3.ElementClicked',
  ElementViewed = 'redventures.usertracking.v3.ElementViewed',
  ConversionTracked = 'core.conversions.ConversionTracked.v2',
  FieldInputted = 'redventures.usertracking.v3.FieldInputted',
}
